import { z } from 'zod';

/**
 * Common Zod schemas shared across race, class, and background schemas
 * These mirror the TypeScript types in @character-creator/types
 */

export const AbilityNameSchema = z.enum([
  'strength',
  'dexterity',
  'constitution',
  'intelligence',
  'wisdom',
  'charisma',
]);

export const SkillNameSchema = z.enum([
  'acrobatics',
  'animal-handling',
  'arcana',
  'athletics',
  'deception',
  'history',
  'insight',
  'intimidation',
  'investigation',
  'medicine',
  'nature',
  'perception',
  'performance',
  'persuasion',
  'religion',
  'sleight-of-hand',
  'stealth',
  'survival',
]);

export const SizeSchema = z.enum([
  'tiny',
  'small',
  'medium',
  'large',
  'huge',
  'gargantuan',
]);

export const DieTypeSchema = z.enum(['d4', 'd6', 'd8', 'd10', 'd12', 'd20']);

export const ArmorCategorySchema = z.enum(['light', 'medium', 'heavy', 'shield']);

export const WeaponCategorySchema = z.enum(['simple', 'martial']);

export const SpellSchoolSchema = z.enum([
  'abjuration',
  'conjuration',
  'divination',
  'enchantment',
  'evocation',
  'illusion',
  'necromancy',
  'transmutation',
]);

export const AlignmentSchema = z.enum([
  'lawful-good',
  'neutral-good',
  'chaotic-good',
  'lawful-neutral',
  'true-neutral',
  'chaotic-neutral',
  'lawful-evil',
  'neutral-evil',
  'chaotic-evil',
  'unaligned',
]);

export const SourceSchema = z.enum(['srd-5.1', 'ignus']);
